import { getUpdatedData } from "components/Form/components/SchemaForm/SchemaFormService";
import { SchemaFieldTypeExtended } from "config/config";
import { CustomFilterValues } from "containers/AdvancedSearch/AdvancedSearch";
import {
    getMatchingSchema,
    getOperatorList,
    isBooleanTypeOperator,
} from "containers/Filter/FilterBuilder/utils";
import { useEffect, useState } from "react";

interface ValueThroughContextMenuProps {
    customFormValues: CustomFilterValues;
    matchingFields: SchemaFieldTypeExtended[];
    setCustomFormValues: (customFilter: any) => void;
}

export const useValueThroughContextMenu = ({
    customFormValues,
    matchingFields,
    setCustomFormValues,
}: ValueThroughContextMenuProps) => {
    const [valueThroughContextMenu, setValueThroughContextMenu] = useState<{
        field: string;
        value: any;
    } | null>(null);

    useEffect(() => {
        if (valueThroughContextMenu) {
            const { field, value } = valueThroughContextMenu;

            // in case of indirection filter "created_by--identity.id:project_id--project.id:name"
            // we search for last entry
            const fieldArray = field.split(":");
            const matchingField = fieldArray[fieldArray.length - 1];

            const newMatchingSchema = getMatchingSchema(matchingFields, matchingField);
            const op = getOperatorList(newMatchingSchema)[0].value;
            const completeValue = {
                field,
                op: isBooleanTypeOperator(op) ? "eq" : op,
                value,
            };
            const rootObjectValue = [...(Object.values(customFormValues)?.[0] ?? [])];
            rootObjectValue.push(completeValue);
            const updatedData = getUpdatedData(
                customFormValues,
                Object.keys(customFormValues)?.[0] ?? "and",
                rootObjectValue
            );
            setCustomFormValues(updatedData);
            setValueThroughContextMenu(null);
        }
    }, [customFormValues, valueThroughContextMenu, matchingFields, setCustomFormValues]);

    return {
        valueThroughContextMenu,
        setValueThroughContextMenu,
    };
};
